import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Dashboard, DisplayTrendsData, DoctorRetention, DownloadExcel, Login, MRAnalysis, OnboardingStatistics, Report, SalesDashboard } from "./pages";
import ProtectedRouteWithSidebar from './protectedRoutes';
import { ROUTES } from './comman/constants';


function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path={ROUTES.LOGIN} element={<Login />} />

          {/* Protected Routes with Sidebar */}
          <Route path="/" element={<ProtectedRouteWithSidebar />}>
            <Route path={ROUTES.DASHBOARD} element={<Dashboard />} />
            <Route path={ROUTES.REPORTS} element={<Report />} />
            <Route path={ROUTES.DOCTORRETENSION} element={<DoctorRetention />} />
            <Route path={ROUTES.TRENDS} element={<DisplayTrendsData />} />
            <Route path={ROUTES.DOWNLOADEXCEL} element={<DownloadExcel />} />
            <Route path={ROUTES.ONBOARDING_STATISTICS} element={<OnboardingStatistics />} />
            <Route path={ROUTES.MR_ANALYSIS} element={<MRAnalysis />} />
            <Route path={ROUTES.SALES_DASHBOARD} element={<SalesDashboard />} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
